exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".AddReprocessingJobForm__root .form-group label{width:160px}\n", "", {"version":3,"sources":["/home/runner/work/greenline-web/greenline-web/web/js/components/admin/forms/AddReprocessingJobForm.scss"],"names":[],"mappings":"AAAA,gDAA0C,WAAW,CAAC","file":"AddReprocessingJobForm.scss","sourcesContent":[".root :global(.form-group) :global(label){width:160px}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "AddReprocessingJobForm__root"
};